let _ = require("ES/lib/lodash");
let Balboa = require("ES/services/Balboa");
let esUtils = require("ES/utils/esUtils");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

let fetchJobBoard = function(callback){
	Balboa.api("/search/jobboard", {include_lost: true}, function(data){

		let JobBoard = data.data;
		_.each(JobBoard.jobs, function(job){
			if(!_.has(job, "eid")){
				job.eid = job.event_id;
			}
			job.starttime = esUtils.convertFromISO8601(job.starttime_ISO8601);
			job.stoptime = esUtils.convertFromISO8601(job.stoptime_ISO8601);
			job.created = esUtils.convertFromISO8601(job.date_created || job.created_ISO8601);
		});

		callback(null, JobBoard);

	}, function(data){
		callback((data && data.message) || "unknown cause");
	});
};

let msgToJS = function(msg_orig){
	var msg = _.cloneDeep(msg_orig);
	msg.created = esUtils.convertFromISO8601(msg_orig.created_ISO8601);
	_.each(msg, function(val, key){
		if(/_id$/.test(key) || (key === "id")){
			msg[key] = esUtils.toInt(val);
		}
	});
	return msg;
};

module.exports.init = function () {
	RadioService("Marketplace_getMyJobBoard", function(data, callback){
		fetchJobBoard(callback);
	}, function(){
		return 1;
	});

	radio("Marketplace_refreshJobBoard").subscribe(function(){
		fetchJobBoard(function(err, JobBoard){
			if(!err){
				//hack for success response on Marketplace_getMyJobBoard
				radio("Marketplace_getMyJobBoard_succeeded").broadcast(1, JobBoard);
			}
		});
	});

	RadioService("Marketplace_acceptCompliance", function(params, callback){
		Balboa.api(
			"/mpshortlist/acceptcompliance/" + params.event_id,
			params,
			function(data){
				callback(null, data);
			},
			function(data){
				callback((data && data.message) || "unknown cause");
			});
	}, function(params){
		return params.event_id + "|" + params.sid;
	});

	RadioService("Marketplace_getEventLead", function(params, callback){
		Balboa.api("/event/read/" + params.event_id, {
		}, function(data){

			var event = esUtils.convertBalboa3EventToJSEvent(data.data.event);

			callback(null, event);

		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.event_id;
	});

	RadioService("Marketplace_getMPMessages", function(params, callback){
		Balboa.api("/mpmessage/read", params, function(data){
			callback(null, {
				messages: _.map(data.messages, msgToJS)
			});
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return _.get(params, ["event_id"], "all");
	});

    RadioService("Marketplace_applyToJob", function(params, callback){
        Balboa.api("/mpmessage/applytopublicjob", {
            content: params.content,
            event_id: params.eid,
            speaker_id: params.sid,
			agreement: params.agreement
        }, function(data){
            callback(null, msgToJS(data.message));
        }, function (data) {
            callback((data && data.message) || "unknown cause");
        });
    }, function(params){
        return params.eid + "|" + params.sid;
    });

	RadioService("Marketplace_sendMPMessages", function(params, callback){
		Balboa.api("/mpmessage/sendtobuyer", {
			content: params.message,
			event_id: params.eid,
			speaker_id: params.sid,
			skip_compliance: params.skip_compliance
		}, function(data){
			callback(null, msgToJS(data.message));
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.eid + "|" + params.sid;
	});

  RadioService("Marketplace_sendBureauMessages", function(params, callback){
    Balboa.api("/mpmessage/sendtobureau", {
      content: params.message,
      event_id: params.eid,
      speaker_id: params.sid
    }, function(data){
      callback(null);
    }, function (data) {
      callback((data && data.message) || "unknown cause");
    });
  }, function(params){
    return params.eid + "|" + params.sid;
  });

	RadioService("Marketplace_getMPAgreement", function(params, callback){
		Balboa.api("/mpagreement/read", {
			event_id: params.event_id,
			speaker_id: params.speaker_id
		}, function(data){
			let mpa = data.data;

			if(mpa){
				mpa.created = esUtils.convertFromISO8601(mpa.created_ISO8601);
				_.each(mpa.fees, function(f){
					f.due = esUtils.convertFromISO8601(f.due_ISO8601);
				});
			}

			callback(null, mpa);
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.event_id + "|" + params.speaker_id;
	});

	RadioService("Marketplace_markAsRead", function(params, callback){
		Balboa.api("/mpmessage/ireadit", {
			ids: params.message_ids
		}, function(data){
			radio("Marketplace_refreshJobBoard").broadcast();
			callback(null, data);
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});

	RadioService("Marketplace_createMPAgreement", function(params, callback){
		Balboa.api("/mpagreement/createdbyspeaker", {
			event_id: params.event_id,
			speaker_id: params.speaker_id,

			fee_main: params.fee_main,
			fee_materials: params.fee_materials,
			fee_travel: params.fee_travel,

			terms: params.terms,

			initials: params.initials,

			file: params.file,

		}, function(data){
			callback(null, data.data);
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.event_id + "|" + params.speaker_id;
	});

	RadioService("Marketplace_acceptAgreement", function(params, callback){
		Balboa.api("/mpagreement/acceptasspeaker", {
			event_id: params.event_id,
			speaker_id: params.speaker_id,
			initials: params.initials,
		}, function(data){
			callback(null, data.data);
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.event_id + "|" + params.speaker_id;
	});

    RadioService("Marketplace_withdrawOffer", function(params, callback){
        Balboa.api("/mpagreement/archivedbyspeaker", {
            event_id: params.event_id,
            speaker_id: params.speaker_id,
            initials: params.initials,
	        message: params.message
        }, function(data){
            callback(null, data.data);
        }, function (data) {
            callback((data && data.message) || "unknown cause");
        });
    }, function(params){
        return params.event_id + "|" + params.speaker_id;
    });


    RadioService("Marketplace_withdrawShortlist", function(params, callback){
        Balboa.api("/event/speakerwithdrawsfromshortlist/" + params.event_id, {
            speaker_id: params.speaker_id,
        }, function(data){
            callback(null, data.data);
        }, function (data) {
            callback((data && data.message) || "unknown cause");
        });
    }, function(params){
        return params.event_id + "|" + params.speaker_id;
    });


	RadioService("Marketplace_readStripeSettings", function(params, callback){
		Balboa.api("/stripe/getspeakerinfo", {
			speaker_id: params.speaker_id,
		}, function(data){
			callback(null, data.data);
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.speaker_id;
	});

	RadioService("Marketplace_disconnectStripeAccount", function(params, callback){
		Balboa.api("/stripe/disconnectSpeaker", {
			speaker_id: params.speaker_id,
		}, function(data){
			callback(null, data.data);
		}, function (data) {
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.speaker_id;
	});

	RadioService("Marketplace_mpmembership", function(params, callback){
		Balboa.api("/speaker/mpmembership/" + params.sid, {
			accepted: params.accepted,
			initials: params.initials
		}, function(data){
			callback(null, data.message || "Recorded your response.");
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.sid;
	});

	RadioService("Marketplace_getShortprofile", function(params, callback){
		Balboa.api("/speaker/shortprofile", {
			speaker_ids: params.sid
		}, function(data){
			callback(null, _.get(data, ["data", params.sid]));
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	}, function(params){
		return params.sid;
	});

};



// WEBPACK FOOTER //
// ./src/services/Marketplace.js